import * as React from "react";

import { RequestProductsSearch } from "../../model";

import { PlpDataSourceProductListQueryProvider } from "./plp-data-source-product-list-query-provider";

export interface PlpDataSourceProductListControllerConsumerInterface {
  requestProductList: (desiredProductList: RequestProductsSearch) => void;
}

const defaultValue =
  {} as unknown as PlpDataSourceProductListControllerConsumerInterface;

const PlpDataSourceProductListControllerContext =
  React.createContext(defaultValue);

export const PlpDataSourceProductListControllerProvider: React.FunctionComponent =
  (props) => {
    const [desiredProductList, setDesiredProductList] =
      React.useState<RequestProductsSearch | null>();

    const requestProductList: PlpDataSourceProductListControllerConsumerInterface["requestProductList"] =
      React.useCallback((desiredProductList) => {
        setDesiredProductList(desiredProductList);
      }, []);

    const value: PlpDataSourceProductListControllerConsumerInterface =
      React.useMemo(
        () => ({
          requestProductList,
        }),
        [requestProductList]
      );

    return (
      <PlpDataSourceProductListControllerContext.Provider value={value}>
        {desiredProductList ? (
          <PlpDataSourceProductListQueryProvider
            desiredProductList={desiredProductList}
          >
            {props?.children || []}
          </PlpDataSourceProductListQueryProvider>
        ) : (
          <React.Fragment>{props?.children || []}</React.Fragment>
        )}
      </PlpDataSourceProductListControllerContext.Provider>
    );
  };

export const usePlpDataSourceProductListController = () => {
  const context = React.useContext(PlpDataSourceProductListControllerContext);
  if (context === defaultValue) {
    throw new Error(
      "usePlpDataSourceProductListController must be used within a PlpDataSourceProductListControllerProvider"
    );
  }
  return context;
};
